import { Slider } from "@/components/ui/slider";

export const SliderField = ({ label, value, min, max, onChange, testid, hint }) => (
  <div>
    <div className="flex items-baseline justify-between">
      <label className="text-sm font-semibold text-ink">{label}</label>
      <span className="font-display text-lg font-extrabold" data-testid={`${testid}-value`}>{value}</span>
    </div>
    <Slider className="mt-3" value={[value]} min={min} max={max} step={1} onValueChange={([v]) => onChange(v)} data-testid={testid} />
    {hint && <p className="mt-1.5 text-xs text-stone-500">{hint}</p>}
  </div>
);
